import httpsStrapi from '../../../config/httpsStrapi'

export const getLegalNoticeProductUpload = (lang) => {
  return httpsStrapi.get(`/legal-notice-product-upload?locale=${lang}&populate=*`)
}
